import {ChildEntity, Column} from "typeorm";
import {Division} from ".";
import {Min} from "class-validator";

@ChildEntity()
export class KODivision extends Division {
  @Column({type: 'integer', unsigned: true})
  @Min(1)
  round?: number;
}
